import { getI18n } from 'react-i18next';

export const VALIDATION_AUCTIONEER_DATA_DUPLICATE_MEMBER_COUNTRY_COMBINATION = 'validation.auctioneerData.duplicateMemberCountryCombination';
export const VALIDATION_AUCTIONEER_DATA_INVALID_COUNTRY = 'validation.auctioneerData.invalidCountry';
export const VALIDATION_AUCTIONEER_DATA_INVALID_MEMBER = 'validation.auctioneerData.invalidMember';
export const VALIDATION_AUCTIONEER_DATA_NEGATIVE_CELL_VALUE = 'validation.auctioneerData.negativeCellValue';
export const VALIDATION_AUCTIONEER_DATA_INVALID_QUANTITY_SUM = 'validation.auctioneerData.invalidQuantitySum';
export const VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_MEMBER = 'validation.auctioneerData.item.invalidMember';
export const VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_COUNTRY = 'validation.auctioneerData.item.invalidCountry';
export const VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_QUANTITY = 'validation.auctioneerData.item.invalidQuantity';

export const createAuctioneerDataMatrixErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_AUCTIONEER_DATA_DUPLICATE_MEMBER_COUNTRY_COMBINATION:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-duplicate-member-country-combination');
            break;
        case VALIDATION_AUCTIONEER_DATA_INVALID_QUANTITY_SUM:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-invalid-quantity-sum');
            break;
        case VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_MEMBER:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-item-invalid-member');
            break;
        case VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_COUNTRY:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-item-invalid-country');
            break;
        case VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_QUANTITY:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-item-invalid-quantity');
            break;
        case VALIDATION_AUCTIONEER_DATA_INVALID_COUNTRY:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-invalid-country', params);
            break;
        case VALIDATION_AUCTIONEER_DATA_INVALID_MEMBER:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-invalid-member', params);
            break;
        case VALIDATION_AUCTIONEER_DATA_NEGATIVE_CELL_VALUE:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-negative-cell-value', params);
            break;
        default:
            result = undefined;
    }
    return result;
};
